import * as React from 'react';
import { DialogSize } from '@economic/taco';
import { SalesDialogFormProps, SalesDialogForm } from './SalesDialogForm';
import { SendEmailOptionsDrawer, PdfAttachmentOptions, FullAttachmentOptions, EncryptOption } from './SendEmailOptionsDrawer';
import { SendEinvoiceOptionsDrawer } from './SendEinvoiceOptionsDrawer';
import { emailOptionsValidationSchema } from '../../invoices/utils/emailOptionsValidationSchema';
import { SendByType } from '../../invoices/book-and-send/types';

type Props = Omit<SalesDialogFormProps, 'drawer' | 'validationSchema'> & {
    hideRecipientsSection?: boolean;
    hideRemember?: boolean;
    fullEmailDrawerAttachmentsOptions?: boolean;
    hideAttachmentOptions?: boolean;
    isBulkSending?: boolean;
    size?: DialogSize;
};

export function SalesDialogFormWithEmailOptionsDrawer({
    hideRecipientsSection,
    hideRemember,
    fullEmailDrawerAttachmentsOptions,
    hideAttachmentOptions,
    size,
    initialData,
    isBulkSending = false,
    ...rest
}: Props) {
    return (
        <SalesDialogForm
            drawer={formValues =>
                formValues.sendByType === SendByType.oioxml ? (
                    <SendEinvoiceOptionsDrawer
                        customerNumber={initialData.eInvoiceOptions?.customerNumber}
                        isCvrReadOnly={!!initialData.eInvoiceOptions?.cvr}
                        disableDrawer={isBulkSending}
                    />
                ) : (
                    <SendEmailOptionsDrawer
                        hideRemember={!!hideRemember || formValues.hasEmailTemplates}
                        hideRecipientsSection={hideRecipientsSection}>
                        {hideAttachmentOptions ? (
                            <EncryptOption />
                        ) : fullEmailDrawerAttachmentsOptions ? (
                            <FullAttachmentOptions />
                        ) : (
                            <PdfAttachmentOptions />
                        )}
                    </SendEmailOptionsDrawer>
                )
            }
            validationSchema={emailOptionsValidationSchema()}
            size={size}
            initialData={initialData}
            {...rest}
        />
    );
}
